import { Fragment } from "react";
import cx from "classnames";
import { Button, Icon, Loader, Table } from "semantic-ui-react";

import MarketplaceCarrierIcon from "components/MarketplaceIcon/MarketplaceCarrierIcon";
import CarrierLabelBadge from "../CarrierLabelBadge/CarrierLabelBadge";
import { IS_EU } from "shared/constants/envConstants";
import { CarrierListRowCellsSizeProps } from "./CarrierListRow";
import { CarrierListColumnKey } from "./carrierListColumns";

import styles from "../CarrierList.module.scss";

const CarrierListRowCellsLarge = (props: CarrierListRowCellsSizeProps) => {
  const cellsByColumn: Record<CarrierListColumnKey, JSX.Element> = {
    actions: (
      <Table.Cell collapsing>
        <Button
          type="button"
          size="tiny"
          color="blue"
          onClick={props.handleCarrierEdit}
        >
          View / Edit
        </Button>

        {props.isLoadingStarredStatus ? (
          <Loader active inline size="mini" className={styles.sizedIcon} />
        ) : (
          <Icon
            aria-label="star"
            name="star"
            link
            className={styles.sizedIcon}
            color={props.carrier.isFavoritedByCurrentUser ? "yellow" : "grey"}
            onClick={props.handleCarrierStar}
          />
        )}
      </Table.Cell>
    ),

    status: (
      <Table.Cell collapsing>
        <CarrierLabelBadge {...props.carrier} />
      </Table.Cell>
    ),

    carrier: (
      <Table.Cell className={cx(styles.carrierNameCell, styles.truncate)}>
        <div
          className={cx(styles.carrierName, styles.carrierNameLink)}
          title={props.cellValues.carrierName}
          onClick={props.handleCarrierEdit}
        >
          {props.cellValues.carrierName}
        </div>
      </Table.Cell>
    ),

    phone: (
      <Table.Cell className={styles.truncate}>
        {props.cellValues.phone}
      </Table.Cell>
    ),

    email: (
      <Table.Cell className={styles.truncate} title={props.cellValues.email}>
        {props.cellValues.email}
      </Table.Cell>
    ),

    cityState: (
      <Table.Cell className={styles.truncate}>
        {props.cellValues.address}
      </Table.Cell>
    ),

    country: (
      <Table.Cell className={styles.truncate}>
        {props.cellValues.country}
      </Table.Cell>
    ),

    repAccount: (
      <Table.Cell
        className={cx(
          styles.truncate,
          props.isOwnedByCurrentUser ? styles.isCurrentUser : null
        )}
        title={props.cellValues.carrierOwner}
      >
        {props.cellValues.carrierOwner}
      </Table.Cell>
    ),

    fleetSize: (
      <Table.Cell className={styles.truncate}>
        {props.cellValues.fleetSize}
      </Table.Cell>
    ),

    shippeoOnboarded: (
      <Table.Cell className={styles.truncate}>
        {props.cellValues.shippeoOnboarded}
      </Table.Cell>
    ),

    lastActivity: (
      <Table.Cell className={styles.truncate}>
        {props.cellValues.lastActivityTime}
      </Table.Cell>
    ),

    lastDelivered: (
      <Table.Cell className={styles.truncate}>
        {props.cellValues.lastShipmentDelivered}
      </Table.Cell>
    ),

    note: (
      <Table.Cell className={styles.truncate}>
        <div title={props.cellValues.lastActivitySummary}>
          {props.cellValues.lastActivitySummary}
        </div>
        <div title={props.cellValues.lastActivityNote} className={styles.grey}>
          {props.cellValues.lastActivityNote}
        </div>
      </Table.Cell>
    ),

    marketplace: (
      <Table.Cell collapsing>
        {!IS_EU ? <MarketplaceCarrierIcon profile={props.carrier} /> : null}
      </Table.Cell>
    ),
  };

  return (
    <>
      {props.visibleColumns.map((columnKey) => (
        <Fragment key={columnKey}>{cellsByColumn[columnKey]}</Fragment>
      ))}
    </>
  );
};

export default CarrierListRowCellsLarge;
